import { render, staticRenderFns } from "./order_assignments.vue?vue&type=template&id=6b9f8ed8&scoped=true"
import script from "./order_assignments.vue?vue&type=script&lang=js"
export * from "./order_assignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9f8ed8",
  null
  
)

export default component.exports